var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TheNavbar',{attrs:{"project-open":!!_vm.words}}),(!_vm.words)?_c('b-container',[_c('FileUpload'),_c('SettingsModal',{staticClass:"mt-3"}),(_vm.isLoading)?_c('BaseProgressBar',{staticClass:"mt-3"}):_vm._e()],1):_vm._e(),(_vm.words)?_c('div',[_c('BaseTable',{attrs:{"words":_vm.words}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }